export default __webpack_public_path__ + "static/TierThree-6674097e5098408273fef9f6b2067bb1.webp";